import { DialogContent } from '@mui/material'
import React from 'react'

import ResultItem, { statusColor } from '#/components/Jobs/ResultItem'

export default function JobDetailContent(props) {
  const { result, sx } = props
  const maxHeight = result?.length ? '50vh' : null
  return (
    <DialogContent sx={{ padding: 0, overflow: 'auto', maxHeight, ...sx }}>
      {result?.map(row => {
        return (
          <ResultItem
            row={row}
            showStatus
            sx={{
              mb: '1px',
              borderLeft: `5px solid ${statusColor(row?.status?.status)}`,
              borderBottom: '1px solid #f1f1f1',
            }}
          />
        )
      })}
    </DialogContent>
  )
}
